import apiResponse from '../api/ApiResponse';
import { QuestionnaireSittingStore } from '@stores/QuestionnaireSittingStore';
import { SectionView } from '@views';
import { DrawerSectionSource, NextSurveySectionResponse } from '@viewCreators/next-survey-section-view-creator';
import actionResponse, { ActionResponse } from './ActionResponse';
import { SaveSurveyResponsesAction } from './SaveSurveyResponsesAction';
import { useMutation } from '@tanstack/react-query';

/** Saves the drawer's answered section to wherever it came from: a survey or a questionnaire sitting. */
export class SaveDrawerSectionAction {
  constructor(
    private readonly saveSurveyResponsesAction: SaveSurveyResponsesAction = new SaveSurveyResponsesAction(),
    private readonly questionnaireSittingStore: QuestionnaireSittingStore = new QuestionnaireSittingStore()
  ) {}

  public async Execute(
    view: NextSurveySectionResponse,
    section: SectionView,
    groupId: number
  ): Promise<ActionResponse> {
    if (view.source === DrawerSectionSource.Survey) {
      return this.saveSurveyResponsesAction.Execute(section, groupId, view.surveyId!);
    }
    try {
      await apiResponse.handleApiResponse(() =>
        this.questionnaireSittingStore.SubmitAnswers(groupId, view.sittingId!, section)
      );
      return actionResponse.Success('saved questionnaire answers');
    } catch (err) {
      return actionResponse.HandleError(err);
    }
  }
}

export const useSaveDrawerSectionAction = () =>
  useMutation({
    mutationFn: async (argument: { view: NextSurveySectionResponse; section: SectionView; groupId: number }) => {
      const action = new SaveDrawerSectionAction();
      return action.Execute(argument.view, argument.section, argument.groupId);
    },
  });
